'use client'
import { useAuth } from '@/context/AuthContext'

export default function AppLink({ href }) {
  const { currentUser } = useAuth()
  if (!currentUser) return null
  return (
    <a href={href}
      className="inline-flex items-center gap-1.5 text-xs font-semibold text-blue-600 bg-blue-50 hover:bg-blue-100 px-3 py-1.5 rounded-full transition-colors">
      <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
      Open in My FairFares
    </a>
  )
}
